export const ELEMENT_ACTION = {
  mail: 'mail',
  exit: 'exit',
  call: 'call',
  close: 'close',
  modal: 'modal',
  download: 'download',
};

// eslint-disable-next-line no-shadow
export enum LeadType {
  LEAD_HARD = 'lead-hard',
  LEAD_SOFT = 'lead-soft',
}
